import _ from "lodash";
import $ from "jquery";
import ComponentUtils from "@/utils/ComponentUtils";
import imagesLoaded from "imagesloaded";

export default {
  computed: {
    hasData() {
      return true;
    }
  },
  methods: _.assign(
    {
      imageLoadedDone() {
        this.$nextTick(() => {
          this.$store.commit("setIsReady", true);
          this._imagesloaded();
        });
      },
      _imagesloaded() {},
      __init() {
        this.$nextTick(() => {
          if (this.hasData && !this.isInit) {
            imagesLoaded(this.$el, { background: true }, this.imageLoadedDone);
            if (!$("html").hasClass("ua-mobile")) {
              $(".kern, .works-post h4")
                .css({
                  "-webkit-font-feature-settings": "",
                  "font-feature-settings": ""
                })
                .kerning();
            }

            this.isInit = true;
          }
        });
      }
    },
    ComponentUtils
  ),
  destroyed() {
    this.$store.commit("setIsReady", false);
  },
  updated() {
    this.__init();
  },
  mounted() {
    this.__init();
  }
};
